import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import useApi from '../../../utils/api-manager/Helper/useApi';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CustomInput from '../../custominput/CustomInput';
import { IconButton } from '@mui/material';
import { useToastHandler } from '../ToastHandler';

const ChangePassword = () => {
  const { Post } = useApi();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({ newPassword: '', confirmPassword: '' });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const { handleToast } = useToastHandler();
  const navigate = useNavigate();

  const validate = () => {
    let isValid = true;
    const newErrors = { newPassword: '', confirmPassword: '' };

    if (!newPassword) {
      newErrors.newPassword = 'New password is required.';
      isValid = false;
    } else if (newPassword.length < 6) {
      newErrors.newPassword = 'Password must be at least 6 characters.';
      isValid = false;
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = 'Please confirm your password.';
      isValid = false;
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = 'Passwords do not match.';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const payload = { new_password: newPassword };
      await Post('changeMyPassword', payload);
      handleToast({ type: 'SUCCESS', message: 'Password changed successfully.' });
      navigate('/');
      setNewPassword('');
      setConfirmPassword('');
    } catch (error) {
      handleToast({
        type: 'ERROR',
        message: error.response?.data?.message || 'Error changing password.',
      });
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '75vh',
        padding: '20px',
        borderRadius: '6px',
        flexDirection: 'column',
      }}
    >
      <div className="container" style={{ maxWidth: '500px', width: '100%', position: 'relative' }}>
        <i
          className="fa-solid fa-arrow-left"
          onClick={() => navigate('/login')}
          style={{
            position: 'absolute',
            top: '-160px',
            // bottom:"10px",
            right: '0px',
            fontSize: '20px',
            cursor: 'pointer',
            color: '#000',
          }}
        ></i>
        <div style={{ width: '100%' }}>
          <h2 style={{  fontWeight: '700', textAlign: 'left' }}>
            Change Password
          </h2>
          <form
            onSubmit={handleSubmit}
            noValidate
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          >
            {/* New Password */}
            <div style={{ marginBottom: '15px', width: '100%' }}>
              <div style={{ display: 'flex', marginTop: '18px' }}>
                <CustomInput
                  id="newPassword"
                  placeholder="New Password"
                  type={showNewPassword ? 'text' : 'password'}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  style={{ flex: 1 }}
                />
                <IconButton
                  type="button"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                  style={{ marginLeft: '5px', color: '#000' }}
                >
                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </div>
              {errors.newPassword && (
                <p style={{ color: 'red', marginTop: '5px' }}>{errors.newPassword}</p>
              )}
            </div>

            {/* Confirm Password */}
            <div style={{ marginBottom: '15px', width: '100%' }}>
              <div style={{ display: 'flex' }}>
                <CustomInput
                  id="confirmPassword"
                  placeholder="Confirm Password"
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  style={{ flex: 1 }}
                />
                <IconButton
                  type="button"
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                  style={{ marginLeft: '5px', color: '#000' }}
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </div>
              {errors.confirmPassword && (
                <p style={{ color: 'red', marginTop: '5px' }}>{errors.confirmPassword}</p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              style={{
                color: '#ffffff',
                width: '100%',
                maxWidth: '232px',
                height: '42px',
                borderRadius: '21px',
                backgroundColor: '#0D532F',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              Change Password
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
